import { render, staticRenderFns } from "./bottomNav.vue?vue&type=template&id=4616faf6"
import script from "./bottomNav.vue?vue&type=script&lang=js"
export * from "./bottomNav.vue?vue&type=script&lang=js"
import style0 from "./bottomNav.vue?vue&type=style&index=0&id=4616faf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports